import { render, staticRenderFns } from "./u-tooltip.vue?vue&type=template&id=3996f762&scoped=true&"
import script from "./u-tooltip.vue?vue&type=script&lang=js&"
export * from "./u-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./u-tooltip.vue?vue&type=style&index=0&id=3996f762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3996f762",
  null
  
)

export default component.exports